import { mapActions, mapState } from 'vuex';
import disqusMixin from '@/mixins/disqus';

export default {
  mixins: [disqusMixin],
  props: {
    showInfoOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('market', ['market', 'isDiscussionPinned', 'activeMarketTab']),
    isOnMarketPage() {
      return this.$route.name === 'market-details';
    },
    isDiscussionTabActive() {
      return this.isOnMarketPage && this.activeMarketTab === 'discussion';
    },
  },
  methods: {
    ...mapActions('market', ['toggleDiscussionPin']),
  },
};
